/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Feature capabilities for the back-office players area, derived from the customer's plugin mappings.
 * @export
 * @interface PlayerCapabilities
 */
export interface PlayerCapabilities {
    /**
     * True when the customer's players are first-party (PAM) managed and therefore editable in the back office.
     * @type {boolean}
     * @memberof PlayerCapabilities
     */
    isEditable: boolean;
}

/**
 * Check if a given object implements the PlayerCapabilities interface.
 */
export function instanceOfPlayerCapabilities(value: object): value is PlayerCapabilities {
    if (!('isEditable' in value) || value['isEditable'] === undefined) return false;
    return true;
}

export function PlayerCapabilitiesFromJSON(json: any): PlayerCapabilities {
    return PlayerCapabilitiesFromJSONTyped(json, false);
}

export function PlayerCapabilitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerCapabilities {
    if (json == null) {
        return json;
    }
    return {
        
        'isEditable': json['isEditable'],
    };
}

export function PlayerCapabilitiesToJSON(value?: PlayerCapabilities | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isEditable': value['isEditable'],
    };
}

